declare namespace $ {

	type $mol_check_box__title_shm_hitalama_map_widget_float_settings_text_md_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_widget_float_settings_text_md_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_settings_text_md['link_favicon'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_map_widget_float_settings_text_md extends $shm_hitalama_map_widget_float_settings {
		link_favicon( next?: boolean ): boolean
		Link_favicon( ): $mol_check_box
		controlled_settings_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=md.view.tree.d.ts.map